export { default } from './AccordionButton';



// WEBPACK FOOTER //
// ./src/components/atoms/AccordionButton/index.js